import { Outlet } from "react-router-dom";
import { useState } from "react";
import { Page } from "../../components/Page";
import {
  ContentWrapper,
  SidebarWrapper,
  Backdrop,
  MainContent,
} from "../../components/LayoutComponents";
import { AppNavbar } from "../components/AppNavbar";
import { ResellerSidebar } from "./ResellerSidebar";
import { useParams } from "react-router-dom";
import type { ResellerId } from "@KassaroAB/shared/types/ids";
import { NotFoundView } from "../NotFoundView";

export const ResellerLayout = () => {
  const { resellerId } = useParams<{ resellerId: ResellerId }>();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  if (!resellerId) {
    return <NotFoundView />;
  }

  return (
    <Page
      fullHeight
      navbar={
        <AppNavbar onMenuClick={handleSidebarToggle} />
      }
    >
      <ContentWrapper>
        <Backdrop $isOpen={sidebarOpen} onClick={handleSidebarClose} />
        <SidebarWrapper $isOpen={sidebarOpen}>
          <ResellerSidebar resellerId={resellerId} onNavigate={handleSidebarClose} />
        </SidebarWrapper>
        <MainContent>
          <Outlet />
        </MainContent>
      </ContentWrapper>
    </Page>
  );
};
